<template>
  <v-col cols="12" class="d-flex justify-space-between">
    <span class="half-width sub--text">{{ label }}:</span>
    <span class="half-width dark-color--text">
      <slot>{{ value }}</slot>
    </span>
  </v-col>
</template>

<script>
export default {
  name: 'AdminDetailRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>
